var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldDesigntools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.12 12.379-7.75 7.74.93.93c.78.78 1.59 1.17 2.39 1.17s1.61-.39 2.39-1.17l2.96-2.96c1.59-1.6 1.59-3.21 0-4.81l-.92-.9zM5.9 2.931l-2.97 2.96c-1.56 1.57-1.56 3.22 0 4.79l.92.92 7.75-7.75-.91-.92c-1.57-1.57-3.22-1.57-4.79 0zM14.66 14.268a5.962 5.962 0 0 0-5.07-4.96c2.8-2.86 7.1-5.89 10.38-7.21.58-.22 1.16-.05 1.52.31.38.38.56.95.32 1.53-1.31 3.27-4.3 7.54-7.15 10.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.18 15.59-1.79 1.43c0-.03-.01-.07-.01-.11-.14-1.07-.64-2.06-1.45-2.87a5.029 5.029 0 0 0-2.96-1.46c-.03 0-.07-.01-.1-.01l1.45-1.83c.14-.18.29-.35.45-.53l.68.09c2.15.3 3.88 1.99 4.22 4.13l.11.66c-.2.17-.4.34-.6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21 20.56c-.61.62-1.43 1.04-2.43 1.16l-2.45.27c-1.34.15-2.49-1-2.34-2.35l.27-2.46c.24-2.19 2.07-3.59 4.01-3.63.19-.01.4 0 .6.02.85.11 1.67.5 2.36 1.18.67.67 1.05 1.46 1.16 2.29.02.2.04.39.04.58 0 1.1-.42 2.15-1.22 2.94z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldDesigntools);
export default __webpack_public_path__ + "static/media/vuesax-bold-designtools.a99f561dd1316f6f2def766e8b7818b4.svg";
export { ForwardRef as ReactComponent };